// extracted by mini-css-extract-plugin
export default {"item":"TodoItem_item__lp-jl"};